import React, { useState, useEffect, useRef } from 'react';
import './ContactModal.css';

const ContactModal = ({ isOpen, onClose, defaultService }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    correo: '',
    servicio: defaultService || ''
  });
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [status, setStatus] = useState(null); 
  
  // Referencia para inyectar el widget de forma nativa
  const turnstileRef = useRef(null);

  // Actualizar el servicio si cambia de página
  useEffect(() => {
    if (defaultService) {
      setFormData((prev) => ({ ...prev, servicio: defaultService }));
    }
  }, [defaultService]);

  // Cargar Cloudflare Turnstile de forma nativa
  useEffect(() => {
    if (!isOpen) return;

    setTurnstileToken(null); // Reiniciar el token al abrir

    const renderWidget = () => {
      if (window.turnstile && turnstileRef.current) {
        // Limpiamos por si se había renderizado antes
        turnstileRef.current.innerHTML = '';
        window.turnstile.render(turnstileRef.current, {
          sitekey: '0x4AAAAAAFJl_OSPDAUNmwaQ', // <-- PEGA TU CLAVE DEL SITIO AQUÍ
          callback: (token) => setTurnstileToken(token)
        });
      }
    };

    // Si el script de Cloudflare no existe, lo creamos
    if (!window.turnstile) {
      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      document.head.appendChild(script);
      script.onload = renderWidget;
    } else {
      // Si ya existía, solo lo renderizamos
      renderWidget();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!turnstileToken) {
      setStatus('Por favor, completa la verificación de seguridad.');
      return;
    }

    setStatus('sending');

    const dataToSend = {
      ...formData,
      'cf-turnstile-response': turnstileToken
    };

    try {
      const response = await fetch('/contact1/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(dataToSend)
      });
      
      const result = await response.json();
      
      if (result.status === 'success') {
        setStatus('success');
        setTimeout(() => {
          onClose();
          setStatus(null);
          setFormData({ nombre: '', telefono: '', correo: '', servicio: defaultService });
          setTurnstileToken(null);
        }, 3000);
      } else {
        setStatus(result.message || 'Error al enviar el mensaje.');
      }
    } catch (error) {
      console.error(error);
      setStatus('Error al conectar con el servidor. Intenta más tarde.');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>&times;</button>
        
        {status === 'success' ? (
          <div className="modal-success">
            <h3>¡Mensaje Enviado!</h3>
            <p>Me pondré en contacto contigo a la brevedad.</p>
          </div>
        ) : (
          <>
            <h3 className="modal-title">Solicitar Presupuesto</h3>
            <p className="modal-subtitle">Déjame tus datos y hablemos de tu proyecto.</p>

            <form onSubmit={handleSubmit} className="modal-form">
              <div className="form-group">
                <label>Nombre y Apellido</label>
                <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required placeholder="Ej. Juan Pérez" />
              </div>

              <div className="form-group">
                <label>Teléfono / WhatsApp</label>
                <input type="tel" name="telefono" value={formData.telefono} onChange={handleChange} required placeholder="+54 9 351..." />
              </div>

              <div className="form-group">
                <label>Correo Electrónico</label>
                <input type="email" name="correo" value={formData.correo} onChange={handleChange} required placeholder="tu@correo.com" />
              </div>

              <div className="form-group">
                <label>Servicio de Interés</label>
                <select name="servicio" value={formData.servicio} onChange={handleChange} required>
                  <option value="">Selecciona un servicio</option>
                  <option value="Desarrollo Web y App">Desarrollo Web y App</option>
                  <option value="CMS y Contenidos">CMS y Contenidos</option>
				  <option value="Inteligencia Artificial">Inteligencia Artificial</option>	  
                  <option value="E-Commerce">E-Commerce</option>
                  <option value="Marketing Digital">Marketing Digital</option>
                  <option value="Optimización Web">Optimización Web</option>
                </select>
              </div>

              {/* Aquí es donde se inyecta el widget de forma nativa */}
              <div className="turnstile-container" ref={turnstileRef}></div>

              <button type="submit" className="dev-btn-primary modal-submit-btn" disabled={status === 'sending'}>
                {status === 'sending' ? 'Enviando...' : 'Enviar Solicitud'}
              </button>
              
              {status && status !== 'sending' && status !== 'success' && (
                <p className="modal-error">{status}</p>
              )}
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ContactModal;